import { createReducer, on } from '@ngrx/store';
import {
  FinishCreateUser,
  FinishGetUsers,
  InitCreateUser,
  InitGetUsers,
  SetUserRolesAreReady,
} from './user.actions';

export interface UserState {
  loadingUserForm: boolean;
  loadingGetUsers: boolean;
  loadingSetUserRoles: boolean;
}

export const initialUserState: UserState = {
  loadingUserForm: false,
  loadingGetUsers: false,
  loadingSetUserRoles: false,
};

export const userReducer = createReducer(
  initialUserState,
  on(InitCreateUser, (state) => {
    return {
      ...state,
      loadingUserForm: true,
    };
  }),
  on(FinishCreateUser, (state) => {
    return {
      ...state,
      loadingUserForm: false,
    };
  }),
  on(InitGetUsers, (state) => {
    return {
      ...state,
      loadingGetUsers: true,
    };
  }),
  on(FinishGetUsers, (state) => {
    return {
      ...state,
      loadingGetUsers: false,
    };
  }),
  on(SetUserRolesAreReady, (state, { isReady }) => {
    return {
      ...state,
      loadingSetUserRoles: isReady,
    };
  })
);
